export const CHANGE_LANG = "change lang";

export function changeLang(status) {
	localStorage.setItem("CornyStore_Lang", status);

	return {
		type: CHANGE_LANG,
		payload: status,
	};
}
